import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

import { MeetOurTeamLabels } from 'src/constants'
import { MeetLabels } from 'src/types'
import { ProfileSection } from './ProfileSection'
import { Helmet } from 'react-helmet'
import { OverContainerLoading, PLoadingC } from 'src/components'
import Lottie from 'lottie-react'
import Loading from 'src/components/layout/Main/loading.json'
import { useTranslations } from 'src/provider/LocaleProvider'
export function DetailedProfile() {
    const t = useTranslations();
    const { name } = useParams();
    const { MeetOurTeamInformation } = MeetOurTeamLabels();
    const filteredPerson = MeetOurTeamInformation.find(
      (person) => person.name === name
    );
    const [person, setPerson] = useState<MeetLabels | null>(filteredPerson || null);


    if (!person) {
        return (
            <OverContainerLoading>
                <PLoadingC>
                    <Lottie animationData={Loading} loop={true} />
                </PLoadingC>
            </OverContainerLoading>
        )
    }

    return (
        <>
            <Helmet>
                <title>
                    {person.name ?? ""} - {t('successStories.complement') ?? ''}
                </title>
                <meta
                    name="description"
                    content={t('meetOurTeam.helmet.content') ?? ''}
                />
            </Helmet>

            <ProfileSection person={filteredPerson} />
        </>
    )
}
